export default __webpack_public_path__ + "static/minsoo.kim-991fae6a0a3efe8e6c064c896123554e.png";